import { Form, Formik } from "formik";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import Box from "../components/Box/Box";
import { formDataAtom } from "../App";
import { FormModel } from "../types/FormTypes";
import * as Yup from "yup";
import Progressbar from "../components/Progressbar/Progressbar";
import { MultipleFileUploadField } from "../components/FileUpload/MultipleFileUploadField";
import BackButton from "../components/Buttons/BackButton";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { COMPENSATION_TAXI } from "./Compensation";

export default function CompensationForTaxi() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);

    // Reset specific fields if the selected compensation is not COMPENSATION_TAXI
    useEffect(() => {
        if (formData.compensation === COMPENSATION_TAXI) {
            setFormData((prev) => ({
                ...prev,
                distance: "",
                cartravelfrom: "",
                cartravelto: "",
                carlicenceplate: "",
                carexpenses: []
            }));
        }
    }, [formData.compensation, setFormData]);

    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });
                    navigate("/hur-vill-du-ha-ersattning");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    taxireceipt: Yup.array()
                        .of(Yup.mixed().required("Kvitto är obligatoriskt"))
                        .min(1, "Vänligen bifoga ett kvitto innan du går vidare."),
                })}
            >
                {({ errors, touched, values }) => (
                    <>
                        <div className="flex justify-between items-center">
                            <div className="flex justify-center h-14 md:h-auto mb-1">

                            </div>

                            <div className="xs:w-52 md:w-full max-w-xs md:mb-4">
                                <Progressbar percentage={"60"} />
                            </div>
                        </div>
                        <Form noValidate>
                            <Box>
                                <>
                                    <h2 ref={h2Ref} tabIndex={-1}>
                                        Ersättning för resa med taxi
                                    </h2>

                                    {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                    <p>
                                        Ladda upp kvitto från resan med taxi (bild på kvittot räcker). Du kan få ersättning upp till 1/40-del av gällande prisbasbelopp.
                                    </p>

                                    <MultipleFileUploadField
                                        currentFiles={values.taxireceipt}
                                        multiple={true}
                                        type="Kvitton"
                                        label="Bifoga kvitto från taxiresa"
                                        inputId="taxireceipt"
                                        inputName="taxireceipt"
                                    />
                                </>
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>
                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
